
jQuery(document).ready(function ($) { 
  if ($(".klaviyo-formadd_to_cart").length) {
        var klaviyoformid = $(".klaviyo-formadd_to_cart").data("klaviyoformid");
        var klaviyoproductid = $(".klaviyo-formadd_to_cart").data(
          "klaviyoproductid"
        );
        var klaviyoproductquantity = $(".klaviyo-formadd_to_cart").data(
          "klaviyoproductquantity"
        );
    
        if (klaviyoformid && klaviyoproductid) {
            var selector =
              '.klaviyo-form[data-testid="klaviyo-form-' +
              klaviyoformid +
              '"] button';
        
            $(document).on("click", selector, function (e) {
              e.preventDefault();
              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  id: klaviyoproductid,
                  quantity: klaviyoproductquantity,
                }),
              })
                .then((response) => response.json())
                .then((data) => {
                  refreshCart();
                  console.log(data);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            });
        }
      }
    });
// Scoped listeners for the isolated test form and the productive Alunir discount form.
window.addEventListener("klaviyoForms", function (event) {
  var detail = event && event.detail;

  if (!detail || detail.type !== "submit") {
    return;
  }

  var metricNamesByFormId = {
    RqXFZL: "Alunir Rabatt-Popup angefordert \u2013 Test",
    RQXZ6y: "Alunir Rabatt-Popup angefordert",
    VS2XW6: "Alunir Rabatt-Popup angefordert",
  };
  var metricName = metricNamesByFormId[detail.formId];

  if (!metricName) {
    return;
  }
  var properties = {
    formId: detail.formId,
    pageUrl: window.location.href,
  };

  if (window.klaviyo && typeof window.klaviyo.track === "function") {
    window.klaviyo.track(metricName, properties);
    return;
  }

  window._learnq = window._learnq || [];
  window._learnq.push(["track", metricName, properties]);
});
